'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _ProgressBarStep = require('./ProgressBarStep');

var _ProgressBarStep2 = _interopRequireDefault(_ProgressBarStep);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ProgressBar, _React$Component);

  function ProgressBar() {
    (0, _classCallCheck3.default)(this, ProgressBar);
    return (0, _possibleConstructorReturn3.default)(this, (ProgressBar.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProgressBar, [{
    key: 'checkoutStepIndex',
    value: function checkoutStepIndex() {
      return this.props.availableSteps.indexOf(this.props.currentStep);
    }
  }, {
    key: 'validCheckoutStep',
    value: function validCheckoutStep() {
      return this.checkoutStepIndex() > -1;
    }
  }, {
    key: 'label',
    value: function label(step, currentStep, index, currentStepIndex) {
      var activeClass = index <= currentStepIndex ? 'active' : '';
      var completeClass = index < currentStepIndex ? 'complete' : '';
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { styleName: step + '-label ' + activeClass + ' ' + completeClass },
        t('spree.' + step)
      );
    }
  }, {
    key: 'renderProgressBar',
    value: function renderProgressBar() {
      var _this2 = this;

      return _react2.default.createElement(
        'ul',
        { styleName: 'm-checkoutSteps checkoutStep-' + this.props.currentStep },
        this.props.availableSteps.map(function (step, index) {
          return _react2.default.createElement(
            'li',
            { key: index, styleName: 'm-checkoutStep-' + step },
            _react2.default.createElement(_ProgressBarStep2.default, {
              stepNumber: index + 1,
              index: index,
              currentStep: _this2.checkoutStepIndex(),
              numberOfSteps: _this2.props.availableSteps.length,
              stepName: _this2.props.t('spree.' + step)
            }),
            _this2.label(step, _this2.props.currentStep, index, _this2.checkoutStepIndex())
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var validCheckoutStep = this.validCheckoutStep();

      if (!validCheckoutStep) {
        return _react2.default.createElement('div', { styleName: 'a-checkoutProgressHidden' });
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'a-checkoutProgress' },
        this.renderProgressBar()
      );
    }
  }]);
  return ProgressBar;
}(_react2.default.Component), _class2.propTypes = {
  currentStep: _react.PropTypes.string.isRequired,
  availableSteps: _react.PropTypes.array.isRequired
}, _temp)) || _class) || _class);
exports.default = ProgressBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/ProgressBar/index.js
// module id = 2498
// module chunks = 0